import { useEffect, useMemo, useRef } from 'react'
import isEqual from 'lodash/isEqual'

export function useDeepCompareMemoize(value) {
  const ref = useRef()
  if (!isEqual(value, ref.current)) ref.current = value
  return ref.current
}

export default function useDeepEqualEffect(callback, dependencies, refs = []) {
  const ref = useRef({ refs })
  ref.current.refs = refs
  useEffect(() => callback(...ref.current.refs), useDeepCompareMemoize(dependencies))
}

// I think the refs part of the useDeepEqualEffect above is busted... like they won't actually retain
// an up to date reference, it will still just be a frozen scoped snapshot of the ref values
// trying this new pattern...
// we can fix the above later...
export function useDeepEqualEffect2(callback, dependencies, refs) {
  const refsRef = useRef(refs)
  refsRef.current = refs
  useEffect(() => callback(refsRef), useDeepCompareMemoize(dependencies))
}

export function useDeepEqualMemo(callback, dependencies, refs) {
  const refsRef = useRef(refs)
  refsRef.current = refs
  /*
    eslint-disable-next-line react-hooks/use-memo --

    This utility hook intentionally uses a dynamic dependency array via useDeepCompareMemoize.
    The React Compiler cannot statically analyze this, but it's the core purpose of this hook -
    to provide deep equality comparison for dependencies instead of reference equality.
  */
  return useMemo(() => callback(refsRef), useDeepCompareMemoize(dependencies))
}
